import * as React from 'react';
import { ErrorBoundary, ErrorBoundaryPropsWithRender, withErrorBoundary } from './ErrorBoundary';
import { ErrorPage, ErrorPageProps } from './ErrorPage';

export interface BenefitSolverErrorBoundaryProps extends Omit<ErrorBoundaryPropsWithRender, 'fallbackRender'>, ErrorPageProps {}

export function BenefitSolverErrorBoundary(props: React.PropsWithRef<React.PropsWithChildren<BenefitSolverErrorBoundaryProps>>) {
	const { title, message, onRetry, onHome, onLogOut, ...errorBoundaryProps } = props;
	return (
		<ErrorBoundary
			fallbackRender={({ error, resetErrorBoundary }) => {
				return (
					<ErrorPage
						error={error}
						resetErrorBoundary={resetErrorBoundary}
						title={title}
						message={message}
						onRetry={onRetry}
						onHome={onHome}
						onLogOut={onLogOut}
					/>
				);
			}}
			{...errorBoundaryProps}
		/>
	);
}

export function withBenefitSolverErrorBoundary<P>(Component: React.ComponentType<P>, props?: BenefitSolverErrorBoundaryProps): React.ComponentType<P> {
	const { title, message, onRetry, onHome, onLogOut, ...errorBoundaryProps } = props || {};
	const Wrapped = withErrorBoundary(Component, {
		fallbackRender: ({ error, resetErrorBoundary }) => {
			return (
				<ErrorPage
					error={error}
					resetErrorBoundary={resetErrorBoundary}
					title={title}
					message={message}
					onRetry={onRetry}
					onHome={onHome}
					onLogOut={onLogOut}
				/>
			);
		},
		...errorBoundaryProps
	});

	// Format for display in DevTools
	const name = Component.displayName || Component.name || 'Unknown';
	Wrapped.displayName = `withBenefitSolverErrorBoundary(${name})`;

	return Wrapped;
}
